import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-upload-icon',
  template: `
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_19048_19390)">
        <path
          d="M8.5026 18.3346L8.5026 8.8263L5.46927 11.8596L3.83594 10.168L9.66927 4.33464L15.5026 10.168L13.8693 11.8596L10.8359 8.8263L10.8359 18.3346H8.5026ZM0.335937 5.5013L0.335937 2.0013C0.335937 1.35964 0.56441 0.81033 1.02135 0.353386C1.4783 -0.103559 2.0276 -0.332031 2.66927 -0.332031L16.6693 -0.332031C17.3109 -0.332031 17.8602 -0.103559 18.3172 0.353386C18.7741 0.81033 19.0026 1.35964 19.0026 2.0013V5.5013H16.6693V2.0013L2.66927 2.0013L2.66927 5.5013H0.335937Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_19048_19390">
          <rect
            width="18.6667"
            height="18.6667"
            fill="white"
            transform="translate(0.667969)"
          />
        </clipPath>
      </defs>
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadIconComponent {}
